import { render } from "./AboutUs2.vue?vue&type=template&id=1fbfd387&scoped=true"
import script from "./AboutUs2.vue?vue&type=script&lang=js"
export * from "./AboutUs2.vue?vue&type=script&lang=js"

import "./AboutUs2.vue?vue&type=style&index=0&id=1fbfd387&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbfd387"]])

export default __exports__